import { Model } from '@vuex-orm/core'

export default class RoomPlanMaster extends Model {
  static entity = 'roomPlanMasters'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      maxRooms: this.number(0),
      price: this.number(0),
      roomCapacity: this.number(0),
      roomPlanDescription: this.string(''),
      roomPlanName: this.string('')
    }
  }
}
